import React from "react"
import getMuiTheme from "material-ui/styles/getMuiTheme"
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider"
import Header from "../components/layout/Header"
import LeftNav from "../components/layout/LeftNav"
import AuthenticationStore from "../stores/AuthenticationStore"
import AppStateStore from "../stores/AppStateStore"
import { browserHistory } from "react-router"
import NoMatch from "./NoMatch"
import { amber600, blueGrey500, grey700 } from "material-ui/styles/colors"
import AccountStore from "../stores/AccountStore"
import autobind from "class-autobind"
import { getAuthData, logout } from "../actions/LoginActions"
import * as permissionHelper from "../helpers/permissionHelper"
import { ELoggedInUserType, IAlertDialogContent, IConfirmDialogContent, IFailedCalcAccrualDataInfoDialogContent, INewCustomReportDialogContent, INoteDrawerContent, IPunchExceptionReviewDialogContent, ISuspensePunchReviewDialogContent, ITextProgressSnackbarContent, ITimecardSequenceWarningDialogContent } from "../models"
import ProgressSnackbar from "../components/common/ProgressSnackbar"
import TextProgressSnackbar from "../components/common/TextProgressSnackbar"
import BannerAlert from "../components/common/BannerAlert"
import AlertDialog from "../components/common/AlertDialog"
import ConfirmDialog from "../components/common//ConfirmDialog"
import TimecardSequenceWarningDialog from "../components/timecard_sequence/TimecardSequenceWarningDialog"
import strings from "../localization/strings"
import NotesDrawer from "../components/Notes/notes_drawer/NotesDrawer"
import ExceptionDialog from "../components/record/record_exception/ExceptionDialog"
import SuspensePunchReviewDialog from "../components/punch/SuspensePunchReviewDialog"
import { getSupervisorAccessJobPermission } from "../helpers/jobHelper"
import PayWall from "../components/paywall/Paywall"
import AccountBillingDrawer from "../components/account/AccountBillingDrawer"
import Workflow from "../components/workflow/Workflow"
import * as  appStateActions from "../actions/AppStateActions"
import { IAccountManagerFESettings } from "../models/data/account_manager/AccountManagerFESettings"
import FreeAccountDataLimitUpgradeDialog from "../components/account/FreeAccountDataLimitUpgradeDialog"
import FreeAccountDataUsageBanner from "../components/account/FreeAccountDataUsageBanner"
import FailedCalcAccrualDataInfoDialog from "../components/payroll/FailedCalcAccrualDataInfoDialog"
import NewCustomReportDialog from "../components/report/NewCustomReportDialog"
import MessageCenter from "./message_center/MessageCenter"

const styles = {
	container: {
		display: "flex",
		minHeight: "vh100",
		minWidth: "vw100"
	},
	content: {
		flex: "1 1 100%",
		margin: "auto 0",
		display: "flex"
	}
}
const pageRegexs = {
	main: /^\/$/,
	login: /^\/login$/,
	esDetailTimecard: /^\/es\/timecards$/,
	esDetailPosition: /^\/es\/positions$/,
	esDetailExpenses: /^\/es\/expenses$/,
	esDetailHierarchy: /^\/es\/hierarchies$/,
	esDetailLeaveTracking: /^\/es\/leave_tracking$/,
	esDetailRequestedJobs: /^\/es\/requested_jobs$/,
	esDetailAccrual: /^\/es\/accruals$/,
	esDetailDevice: /^\/es\/devices$/,
	esDetailSchedule: /^\/es\/schedules$/,
	esDetailWorkPreferences: /^\/es\/workpreferences$/,
	esDetailFiles: /^\/es\/files$/,
	employeeDetailTimecard: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/timecards$/,
	employeeDetailPosition: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/positions$/,
	employeeDetailExpenses: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/expenses$/,
	employeeDetailHierarchy: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/hierarchies$/,
	employeeDetailLeaveTracking: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/leave_tracking$/,
	employeeDetailRequestedJobs: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/employee_jobs$/,
	employeeDetailAccrual: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/accruals$/,
	employeeDetailDevice: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/devices$/,
	employeeDetailSchedule: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/schedules$/,
	employeeDetailRecord: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/records$/,
	employeeDetailFacespace: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/facespaces$/,
	employeeDetailWorkPreferences: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/workpreferences$/,
	employeeDetailFiles: /^\/user-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/files$/,
	dashboard: /^\/dashboard$/,
	mobileDashboard: /^\/mobile-dashboard$/,
	employee: /^\/employees$/,
	hierarchyDetail: /^\/hierarchy\/details$/,
	hierarchyChildren: /^\/hierarchy\/children$/,
	hierarchyUser: /^\/hierarchy\/users$/,
	hierarchyEmployee: /^\/hierarchy\/employees$/,
	hierarchyPosition: /^\/hierarchy\/positions$/,
	hierarchyLocation: /^\/hierarchy\/location$/,
	hierarchyRecord: /^\/hierarchy\/records$/,
	hierarchyDevice: /^\/hierarchy\/devices$/,
	hierarchySetting: /^\/hierarchy\/settings$/,
	device: /^\/toplevel-devices$/,
	record: /^\/records$/,
	timecard: /^\/timecards$/,
	equipment: /^\/equipment$/,
	equipmentDetailTimecard: /^\/equipment-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/timecards$/,
	equipmentDetailHistory: /^\/equipment-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/history$/,
	accountBilling: /^\/account\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/Billing$/,
	accountUser: /^\/account\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/Users$/,
	accountHierarchyDefinition: /^\/account\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/HierarchyDefinitions$/,
	accountPosition: /^\/account\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/Positions$/,
	accountSetting: /^\/account\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/Settings$/,
	payroll: /^\/payroll$/,
	oemAdmin: /^\/oem-admin$/,
	i9: /^\/i9$/,
	leaveTracking: /^\/leave-tracking$/,
	shiftTemplate: /^\/schedule\/shift_templates$/,
	patternTemplate: /^\/schedule\/pattern_templates$/,
	scheduleTemplate: /^\/schedule\/schedule_templates$/,
	masterSchedule: /^\/schedule\/master_schedules$/,
	schedulePlanner: /^\/schedule\/schedule_planners$/,
	postedSchedule: /^\/schedule\/posted_schedules$/,
	notificationSettings: /^\/notification_settings$/,
	clients: /^\/clients$/,
	clientDetail: /^\/client-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
	jobs: /^\/jobs$/,
	jobDetail: /^\/job-details\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
	accountManager: /^\/accountmanager$/,
	workflows: /^\/workflows$/,
	gigPool: /^\/gigpool$/,
}
interface IProps {
	params: any
	children: any
}
interface IState {
	logged: boolean
	bannerAlertContent: string
	progressSnackbarContent: string
	textProgressSnackbarContent: ITextProgressSnackbarContent
	alertDialogContent: IAlertDialogContent
	confirmDialogContent: IConfirmDialogContent
	timecardSequenceWarningDialogContent: ITimecardSequenceWarningDialogContent
	noteDrawerContent: INoteDrawerContent
	leftNavExpand: string
	punchExceptionReviewDialogContent: IPunchExceptionReviewDialogContent
	suspensePunchReviewDialogContent: ISuspensePunchReviewDialogContent
	freeAccountDataLimitUpgradeDialogContent: string
	failedCalcAccrualDataInfoDialogContent: IFailedCalcAccrualDataInfoDialogContent[]
	newCustomReportDialogContent: INewCustomReportDialogContent
	accountDrawerOpen: boolean
	messageCenterDrawerOpen: boolean
	frontEndSettings: IAccountManagerFESettings
	noAccessPage: boolean
}

class Layout extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			logged: AuthenticationStore.getLoggedInUser() ? true : false,
			bannerAlertContent: "",
			progressSnackbarContent: "",
			textProgressSnackbarContent: null,
			alertDialogContent: null,
			confirmDialogContent: null,
			timecardSequenceWarningDialogContent: null,
			noteDrawerContent: null,
			leftNavExpand: AppStateStore.getExpandNav(),
			punchExceptionReviewDialogContent: null,
			suspensePunchReviewDialogContent: null,
			freeAccountDataLimitUpgradeDialogContent: null,
			failedCalcAccrualDataInfoDialogContent: null,
			newCustomReportDialogContent: null,
			accountDrawerOpen: new URLSearchParams(window.location.search).get('billing_details') === "true",
			frontEndSettings: null,
			messageCenterDrawerOpen: false,
			noAccessPage: false,
		}
		autobind(this)
	}

	componentWillMount() {
		AppStateStore.on("frontEndSettings_change", this.frontEndSettingsChange)
		appStateActions.getFrontEndSettings()
	}

	componentDidMount() {
		AuthenticationStore.on("change", this.changeEvent)
		AppStateStore.on("change", this.leftNavExpandChange)
		AppStateStore.on("progress_change", this.progressChangeEvent)
		AppStateStore.on("textprogress_change", this.textProgressChangeEvent)
		AppStateStore.on("banner_alert_change", this.bannerAlertChangeEvent)
		AppStateStore.on("alert_change", this.alertChangeEvent)
		AppStateStore.on("timecard_sequence_warning_change", this.timecardSequenceWarningChangeEvent)
		AppStateStore.on("note_drawer_change", this.noteDrawerChangeEvent)
		AppStateStore.on("confirm_change", this.confirmChangeEvent)
		AppStateStore.on("punch_exception_review_dialog_change", this.punchExceptionReviewDialogChangeEvent)
		AppStateStore.on("suspense_punch_review_dialog_change", this.suspensePunchReviewDialogChangeEvent)
		AppStateStore.on("free_account_data_limit_upgrade_dialog_change", this.freeAccountDataLimitUpgradeDialogChangeEvent)
		AppStateStore.on("failed_calc_accrual_data_info_dialog_change", this.failedCalcAccrualDataInfoDialogChangeEvent)
		AppStateStore.on("new_custom_report_dialog_change", this.newCustomReportDialogChangeEvent)
		AccountStore.on("account_change", this.accountChangeEvent)
		AppStateStore.on("open_account_billing", this.openAccountBillingDrawerEvent)
		AppStateStore.on("open_message_center", this.openMessageCenterDrawerEvent)
		AppStateStore.on("no_access_page", this.noAccessPageEvent)
		window.addEventListener("popstate", () => this.setState({ noAccessPage: false }))
		AccountStore.setProxyAccountId(new URLSearchParams(location.search).get("proxy"))

		if (!this.isSSOLogin()) {
			if (!AuthenticationStore.loggedIn()) {
				getAuthData(AuthenticationStore.getCookieUserId())
			}

			if (document.domain === "test.findd.io") {
				window["Intercom"]("update");
			}
		}
	}

	componentWillUnmount() {
		AppStateStore.removeListener("change", this.leftNavExpandChange)
		AccountStore.removeListener("account_change", this.accountChangeEvent)
		AppStateStore.removeListener("progress_change", this.progressChangeEvent)
		AppStateStore.removeListener("textprogress_change", this.textProgressChangeEvent)
		AppStateStore.removeListener("banner_alert_change", this.bannerAlertChangeEvent)
		AppStateStore.removeListener("timecard_sequence_warning_change", this.timecardSequenceWarningChangeEvent)
		AppStateStore.removeListener("note_drawer_change", this.noteDrawerChangeEvent)
		AppStateStore.removeListener("alert_change", this.alertChangeEvent)
		AppStateStore.removeListener("confirm_change", this.confirmChangeEvent)
		AppStateStore.removeListener("punch_exception_review_dialog_change", this.punchExceptionReviewDialogChangeEvent)
		AppStateStore.removeListener("suspense_punch_review_dialog_change", this.suspensePunchReviewDialogChangeEvent)
		AppStateStore.removeListener("open_account_billing", this.openAccountBillingDrawerEvent)
		AppStateStore.removeListener("free_account_data_limit_upgrade_dialog_change", this.freeAccountDataLimitUpgradeDialogChangeEvent)
		AppStateStore.removeListener("failed_calc_accrual_data_info_dialog_change", this.failedCalcAccrualDataInfoDialogChangeEvent)
		AppStateStore.removeListener("new_custom_report_dialog_change", this.newCustomReportDialogChangeEvent)
		AppStateStore.removeListener("open_message_center", this.openMessageCenterDrawerEvent)
		AppStateStore.removeListener("no_access_page", this.noAccessPageEvent)
	}

	frontEndSettingsChange() {
		this.setState({ frontEndSettings: AppStateStore.getFrontEndSettings() })
	}

	openAccountBillingDrawerEvent() {
		this.setState({ accountDrawerOpen: true })
	}

	openMessageCenterDrawerEvent() {
		this.setState({ messageCenterDrawerOpen: true })
	}

	noAccessPageEvent() {
		this.setState({ noAccessPage: true })
	}

	accountChangeEvent() {
		this.forceUpdate()
	}

	changeEvent() {
		if (!AuthenticationStore.getCookieUserId()) {
			if (!this.isSSOLogin()) {
				browserHistory.replace("/login")
			}
		}
		this.setState({
			logged: AuthenticationStore.getLoggedInUser() ? true : false
		})
	}

	textProgressChangeEvent() {
		this.setState({ textProgressSnackbarContent: AppStateStore.getTextProgressSnackbarContent() })
	}

	progressChangeEvent() {
		this.setState({ progressSnackbarContent: AppStateStore.getProgressSnackbarContent() })
	}

	bannerAlertChangeEvent() {
		this.setState({ bannerAlertContent: AppStateStore.getBannerAlertContent() })
	}

	alertChangeEvent() {
		this.setState({ alertDialogContent: AppStateStore.alertDialogContent })
	}

	confirmChangeEvent() {
		this.setState({ confirmDialogContent: AppStateStore.confirmDialogContent })
	}

	timecardSequenceWarningChangeEvent() {
		this.setState({ timecardSequenceWarningDialogContent: AppStateStore.timecardSequenceWarningDialogContent })
	}

	noteDrawerChangeEvent() {
		this.setState({ noteDrawerContent: AppStateStore.noteDrawerContent })
	}

	punchExceptionReviewDialogChangeEvent() {
		this.setState({ punchExceptionReviewDialogContent: AppStateStore.punchExceptionReviewDialogContent })
	}

	suspensePunchReviewDialogChangeEvent() {
		this.setState({ suspensePunchReviewDialogContent: AppStateStore.suspensePunchReviewDialogContent })
	}

	freeAccountDataLimitUpgradeDialogChangeEvent() {
		this.setState({ freeAccountDataLimitUpgradeDialogContent: AppStateStore.freeAccountDataLimitUpgradeDialogContent })
	}

	failedCalcAccrualDataInfoDialogChangeEvent() {
		this.setState({ failedCalcAccrualDataInfoDialogContent: AppStateStore.failedCalcAccrualDataInfoDialogContent })
	}

	newCustomReportDialogChangeEvent() {
		this.setState({ newCustomReportDialogContent: AppStateStore.newCustomReportDialogContent })
	}

	leftNavExpandChange() {
		this.setState({ leftNavExpand: AppStateStore.getExpandNav() })
	}

	onLogoutClick() {
		logout()
	}

	isSSOLogin() {
		return location.pathname.startsWith('/sso-login')
	}

	render() {
		let muiTheme = getMuiTheme({
			palette: {
				primary1Color: blueGrey500,
				accent1Color: amber600,
				textColor: grey700
			},
			flatButton: {
				primaryTextColor: amber600,
				secondaryTextColor: blueGrey500
			}
		})

		if (this.state.frontEndSettings) {
			muiTheme = getMuiTheme({
				palette: {
					primary1Color: this.state.frontEndSettings.UISettings.PrimaryColor,
					accent1Color: this.state.frontEndSettings.UISettings.AccentColor,
					textColor: this.state.frontEndSettings.UISettings.TextColor,
				},
				flatButton: {
					primaryTextColor: this.state.frontEndSettings.UISettings.AccentColor,
					secondaryTextColor: this.state.frontEndSettings.UISettings.TextColor,
				},
				paper: {
					zDepthShadows: [
						"0 3px 10px rgb(0 0 0 / 10%)",
					]
				},
				toggle: {
					thumbOnColor: this.state.frontEndSettings.UISettings.AccentColor,
					trackOnColor: `${this.state.frontEndSettings.UISettings.AccentColor}80`
				}
				/*				
				paper: {
					color: palette.textColor,
					backgroundColor: palette.canvasColor,
					zDepthShadows: [
					  [1, 6, 0.12, 1, 4, 0.12],
					  [3, 10, 0.16, 3, 10, 0.23],
					  [10, 30, 0.19, 6, 10, 0.23],
					  [14, 45, 0.25, 10, 18, 0.22],
					  [19, 60, 0.30, 15, 20, 0.22],
					].map((d) => (
					  `0 ${d[0]}px ${d[1]}px ${fade(palette.shadowColor, d[2])},
					   0 ${d[3]}px ${d[4]}px ${fade(palette.shadowColor, d[5])}`
					)),
				  },
				  */
			})
		}

		if (!this.state.logged || !AccountStore.getCurrentAccount()) {
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<div style={styles.content}>
						{this.isSSOLogin() ?
							React.cloneElement(this.props.children, this.props) :
							<TextProgressSnackbar
								content={{ progressText: strings.Authenticating }}
								close={() => { }}
							/>
						}
					</div>
				</MuiThemeProvider>
			)
		}

		const loggedInUserType = permissionHelper.getLoggedInUserType()
		let isValidPathRegexs = []

		// main page
		isValidPathRegexs.push(pageRegexs.main)

		// login page
		isValidPathRegexs.push(pageRegexs.login)

		// ESS pages
		if (permissionHelper.loggedInUserHasSpecificPermission(AuthenticationStore.SpecialPermission.SelfService) && (loggedInUserType === ELoggedInUserType.Employee || loggedInUserType === ELoggedInUserType.EsAccUser)) {
			if (AccountStore.getTimecardEnabled())
				isValidPathRegexs.push(pageRegexs.esDetailTimecard)

			isValidPathRegexs.push(pageRegexs.esDetailPosition)

			if (AccountStore.getExpensesEnabled())
				isValidPathRegexs.push(pageRegexs.esDetailExpenses)

			if (AccountStore.getExplicitEmployeeHierarchyAssignment())
				isValidPathRegexs.push(pageRegexs.esDetailHierarchy)

			if (AccountStore.getAccrualsTimeoffEnabled())
				isValidPathRegexs.push(pageRegexs.esDetailLeaveTracking, pageRegexs.esDetailAccrual)

			if (AccountStore.getCRMEnabled() && AccountStore.getJobsEnabled())
				isValidPathRegexs.push(pageRegexs.esDetailRequestedJobs)

			if (AccountStore.getScheduleEnabled())
				isValidPathRegexs.push(pageRegexs.esDetailSchedule, pageRegexs.esDetailWorkPreferences, pageRegexs.notificationSettings)

			isValidPathRegexs.push(pageRegexs.esDetailDevice)
			isValidPathRegexs.push(pageRegexs.esDetailFiles)
		}
		if (loggedInUserType !== ELoggedInUserType.Employee) {
			// global admin pages
			if (permissionHelper.isGlobalAdmin())
				isValidPathRegexs.push(pageRegexs.oemAdmin)

			// i9
			if (AccountStore.getI9Enabled())
				isValidPathRegexs.push(pageRegexs.i9)

			// dashboard
			isValidPathRegexs.push(pageRegexs.dashboard)

			//mobile-dashboard
			isValidPathRegexs.push(pageRegexs.mobileDashboard)

			// notification settings page
			isValidPathRegexs.push(pageRegexs.notificationSettings)

			// employee
			if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees)) {
				isValidPathRegexs.push(pageRegexs.employee)

				if (AccountStore.getTimecardEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards))
					isValidPathRegexs.push(pageRegexs.employeeDetailTimecard)

				isValidPathRegexs.push(pageRegexs.employeeDetailPosition)

				if (AccountStore.getExpensesEnabled())
					isValidPathRegexs.push(pageRegexs.employeeDetailExpenses)

				if (AccountStore.getJobsEnabled())
					isValidPathRegexs.push(pageRegexs.employeeDetailRequestedJobs)

				if (AccountStore.getScheduleEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewUserSchedule))
					isValidPathRegexs.push(pageRegexs.employeeDetailSchedule)

				if (AccountStore.getExplicitEmployeeHierarchyAssignment())
					isValidPathRegexs.push(pageRegexs.employeeDetailHierarchy)

				if (AccountStore.getAccrualsTimeoffEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking))
					isValidPathRegexs.push(pageRegexs.employeeDetailLeaveTracking)

				if (AccountStore.getAccrualsTimeoffEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.ViewUserAccrual))
					isValidPathRegexs.push(pageRegexs.employeeDetailAccrual)

				isValidPathRegexs.push(pageRegexs.employeeDetailRecord)

				if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewUserDevices))
					isValidPathRegexs.push(pageRegexs.employeeDetailDevice)

				isValidPathRegexs.push(pageRegexs.employeeDetailFacespace)

				AccountStore.getScheduleEnabled() &&
					isValidPathRegexs.push(pageRegexs.employeeDetailWorkPreferences)

				isValidPathRegexs.push(pageRegexs.employeeDetailFiles)
			}

			// hierarchy
			if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewHierarchyTab)) {
				isValidPathRegexs.push(pageRegexs.hierarchyDetail, pageRegexs.hierarchyChildren, pageRegexs.hierarchySetting)
				if (AccountStore.getExplicitAccountUserHierarchyAssignment())
					isValidPathRegexs.push(pageRegexs.hierarchyUser)

				if (AccountStore.getExplicitEmployeeHierarchyAssignment())
					isValidPathRegexs.push(pageRegexs.hierarchyEmployee)

				isValidPathRegexs.push(pageRegexs.hierarchyPosition)
				isValidPathRegexs.push(pageRegexs.hierarchyLocation)

				if (permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.ViewRecords))
					isValidPathRegexs.push(pageRegexs.hierarchyRecord)
				if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewHierarchyDevices))
					isValidPathRegexs.push(pageRegexs.hierarchyDevice)
			}

			// top level device
			if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewAllDevices))
				isValidPathRegexs.push(pageRegexs.device)

			// record
			if (permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.ViewRecords)) {
				isValidPathRegexs.push(pageRegexs.record)
			}

			// timecard
			if (AccountStore.getTimecardEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards)) {
				isValidPathRegexs.push(pageRegexs.timecard)
			}

			// equipment
			if (AccountStore.getEquipmentEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.ViewEquipment)) {
				isValidPathRegexs.push(pageRegexs.equipment, pageRegexs.equipmentDetailHistory)
				if (AccountStore.getTimecardEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards))
					isValidPathRegexs.push(pageRegexs.equipmentDetailTimecard)
			}

			// account
			if (permissionHelper.isAccountAdmin()) {
				!AccountStore.getHideBilling() &&
					isValidPathRegexs.push(pageRegexs.accountBilling)
				isValidPathRegexs.push(pageRegexs.accountHierarchyDefinition, pageRegexs.accountPosition, pageRegexs.accountUser, pageRegexs.accountSetting)
			}

			// payroll
			if (
				(
					(AccountStore.getPayrollEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll)) ||
					(AccountStore.getExpensesEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense))
				) ||
				AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob)
			)
				isValidPathRegexs.push(pageRegexs.payroll)

			// leave tracking
			if ((!AccountStore.getHidePaywall() && !AccountStore.getAccrualsTimeoffEnabled()) ||
				(AccountStore.getAccrualsTimeoffEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.ViewLeaveTracking)))
				isValidPathRegexs.push(pageRegexs.leaveTracking)

			// schedule
			if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule)) {
				isValidPathRegexs.push(pageRegexs.shiftTemplate, pageRegexs.scheduleTemplate)
				!AppStateStore.hideSchedulePatternTemplate && isValidPathRegexs.push(pageRegexs.patternTemplate)
			}
			if ((!AccountStore.getHidePaywall() && !AccountStore.getScheduleEnabled()) ||
				(AccountStore.getScheduleEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewSchedule))) {
				isValidPathRegexs.push(pageRegexs.masterSchedule, pageRegexs.schedulePlanner, pageRegexs.postedSchedule)
			}

			// jobs
			if (AccountStore.getJobsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.ViewJobs)) {
				isValidPathRegexs.push(pageRegexs.jobs)
				this.props.params.jobId && getSupervisorAccessJobPermission(this.props.params.jobId) &&
					isValidPathRegexs.push(pageRegexs.jobDetail)
			}

			// clients
			if (AccountStore.getClientsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Clients.ViewClients)) {
				isValidPathRegexs.push(pageRegexs.clients)
				isValidPathRegexs.push(pageRegexs.clientDetail)
			}

			// gigpool
			if (AccountStore.getHREnabled()) {
				isValidPathRegexs.push(pageRegexs.gigPool)
			}
		}

		if (loggedInUserType === ELoggedInUserType.AccountManager) {
			isValidPathRegexs.push(pageRegexs.accountManager)
		}

		isValidPathRegexs.push(pageRegexs.workflows)

		if (AuthenticationStore.isCrossProxyError()) {
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<AlertDialog
						open
						title={strings.ProxyNotValidTitle}
						content={strings.ProxyNotValidDetails}
					/>
				</MuiThemeProvider>
			)
		}

		return (isValidPathRegexs.find(item => item.test(location.pathname)) && !this.state.noAccessPage) ?
			<MuiThemeProvider muiTheme={muiTheme}>
				<div className="Layout" style={styles.container}>
					{loggedInUserType !== ELoggedInUserType.AccountManager &&
						<div>
							{AccountStore.getEnableWorkflows() &&
								<Workflow />
							}
							<Header loggedInUserType={loggedInUserType} onLogoutClick={this.onLogoutClick} />
						</div>
					}
					<div style={styles.content}>
						{loggedInUserType !== ELoggedInUserType.AccountManager &&
							<LeftNav params={this.props.params} loggedInUserType={loggedInUserType} page={location.pathname} onLogoutClick={this.onLogoutClick} />
						}
						<div className="page-container" style={{ width: `calc(100vw - ${this.state.leftNavExpand === "collapsed" ? 100 : 244}px)` }}>
							<BannerAlert
								content={this.state.bannerAlertContent}
								close={() => this.setState({ bannerAlertContent: "" })}
							/>
							{React.cloneElement(this.props.children, this.props)}
						</div>
					</div>
					<div style={{ clear: "both" }} />
					{this.state.progressSnackbarContent &&
						<ProgressSnackbar
							content={this.state.progressSnackbarContent}
							close={() => this.setState({ progressSnackbarContent: "" })}
						/>
					}
					{this.state.textProgressSnackbarContent &&
						<TextProgressSnackbar
							content={this.state.textProgressSnackbarContent}
							close={() => this.setState({ textProgressSnackbarContent: null })}
						/>
					}
					{this.state.alertDialogContent &&
						<AlertDialog
							open
							title={this.state.alertDialogContent.title}
							buttonTitle={this.state.alertDialogContent.buttonTitle}
							content={this.state.alertDialogContent.content}
							subContent={this.state.alertDialogContent.subContent}
							icon={this.state.alertDialogContent.icon}
							close={() => {
								AppStateStore.setAlertDialogContent(null)
								this.state.alertDialogContent.handleCloseCallBack &&
									this.state.alertDialogContent.handleCloseCallBack()
							}}
						/>
					}
					{this.state.confirmDialogContent &&
						<ConfirmDialog
							open
							confirmContent={this.state.confirmDialogContent.content}
							title={this.state.confirmDialogContent.title}
							close={() => AppStateStore.setConfirmDialogContent(null)}
							confirm={(action, payload) => {
								AppStateStore.setConfirmDialogContent(null)
								this.state.confirmDialogContent.confirm(action, payload)
							}}
							action={this.state.confirmDialogContent.action}
							payload={this.state.confirmDialogContent.payload}
							subContext={this.state.confirmDialogContent.subContext}
							confirmBtnLabel={this.state.confirmDialogContent.confirmBtnLabel}
							cancelBtnLabel={this.state.confirmDialogContent.cancelBtnLabel}
						/>
					}
					{this.state.timecardSequenceWarningDialogContent &&
						<TimecardSequenceWarningDialog
							selectedPaySettings={this.state.timecardSequenceWarningDialogContent.paySettings}
							warningData={this.state.timecardSequenceWarningDialogContent.warningData}
							handleClose={() => AppStateStore.setTimecardSequenceWarningDialogContent(null)}
							handleRetry={this.state.timecardSequenceWarningDialogContent.handleRetry}
						/>
					}
					{this.state.punchExceptionReviewDialogContent &&
						<ExceptionDialog
							punchId={this.state.punchExceptionReviewDialogContent.exceptionPunchId}
							clickedExceptionType={this.state.punchExceptionReviewDialogContent.clickedExceptionType}
							punches={this.state.punchExceptionReviewDialogContent.punches}
							availableExceptionTypes={this.state.punchExceptionReviewDialogContent.availableExceptionTypes}
							reviewedType={this.state.punchExceptionReviewDialogContent.reviewedType}
							handleClose={() => {
								AppStateStore.setPunchExceptionReviewDialogContent(null)
								this.state.punchExceptionReviewDialogContent.closeCallback &&
									this.state.punchExceptionReviewDialogContent.closeCallback()
							}}
						/>
					}
					{this.state.suspensePunchReviewDialogContent &&
						<SuspensePunchReviewDialog
							punchId={this.state.suspensePunchReviewDialogContent.punchId}
							punchRecords={this.state.suspensePunchReviewDialogContent.records}
							handleClose={changed => {
								AppStateStore.setSuspensePunchReviewDialogContent(null)
								changed &&
									this.state.suspensePunchReviewDialogContent.changedCallback()
							}}
						/>
					}
					{this.state.freeAccountDataLimitUpgradeDialogContent &&
						<FreeAccountDataLimitUpgradeDialog
							content={this.state.freeAccountDataLimitUpgradeDialogContent}
							close={() => this.setState({ freeAccountDataLimitUpgradeDialogContent: null })}
						/>
					}
					{this.state.failedCalcAccrualDataInfoDialogContent &&
						<FailedCalcAccrualDataInfoDialog
							content={this.state.failedCalcAccrualDataInfoDialogContent}
							close={() => AppStateStore.setFailedCalcAccrualDataInfoDialogContent(null)}
						/>
					}
					{this.state.newCustomReportDialogContent &&
						<NewCustomReportDialog
							newCustomReportDoc={this.state.newCustomReportDialogContent.newCustomReportDoc}
							newCustomReportParameters={this.state.newCustomReportDialogContent.newCustomReportParameters}
							handleClose={() => AppStateStore.setNewCustomReportDialogContent(null)}
						/>
					}
					<NotesDrawer
						openNotesDrawer={this.state.noteDrawerContent !== null}
						drawerTitle={this.state.noteDrawerContent ? this.state.noteDrawerContent.drawerTitle : ""}
						objectData={this.state.noteDrawerContent ? this.state.noteDrawerContent.objectData : null}
						objectName={this.state.noteDrawerContent ? this.state.noteDrawerContent.objectName : null}
						dataType={this.state.noteDrawerContent ? this.state.noteDrawerContent.dataType : "all"}
						validationMessages={this.state.noteDrawerContent ? this.state.noteDrawerContent.validationMessages : null}
						closeNotesDrawer={() => this.setState({ noteDrawerContent: null })}
						readValidationMessage={this.state.noteDrawerContent ? (msgId:string)=> this.state.noteDrawerContent.readValidationMessage(msgId) : undefined}
					/>
					{/* let not show FreeAccountDataUsageBanner popup for now. 
					{AccountStore.getCurrentAccount().BillingInfo.PlanType === EPlanType.Free &&
						<FreeAccountDataUsageBanner
							accountDrawerOpen={this.state.accountDrawerOpen}
						/>
					}
					*/}
					{loggedInUserType !== ELoggedInUserType.AccountManager && [
						<PayWall key="paywall" />,
						<AccountBillingDrawer
							key="account_biddling_drawer"
							open={this.state.accountDrawerOpen}
							handleClose={() => this.setState({ accountDrawerOpen: false })}
						/>,
						<MessageCenter
							key="messagecenter"
							open={this.state.messageCenterDrawerOpen}
							handleClose={() => this.setState({ messageCenterDrawerOpen: false })}
						/>
					]}
				</div>
			</MuiThemeProvider> :
			<NoMatch />
	}
}

export default Layout
